(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/fractiongames/assets/redux/actions.js') >= 0) return;  svs.modules.push('/components/numbergames/fractiongames/assets/redux/actions.js');

'use strict';

const apiPaths = svs.numbergames.fractiongames.constants.apiPaths;
const socketPath = apiPaths.socket();
const ACTION_TYPES = {
  SOCKET_SUBSCRIBE: 'SOCKET_SUBSCRIBE',
  SOCKET_UNSUBSCRIBE: 'SOCKET_UNSUBSCRIBE'
};
const actions = {
  socketSubscribe: function () {
    let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : socketPath;
    return {
      type: ACTION_TYPES.SOCKET_SUBSCRIBE,
      path
    };
  },
  socketUnsubscribe: function () {
    let path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : socketPath;
    return {
      type: ACTION_TYPES.SOCKET_UNSUBSCRIBE,
      path
    };
  }
};
Object.assign(svs.numbergames.fractiongames.redux, {
  ACTION_TYPES,
  actions
});

 })(window);